// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("core.ruffle." + {"110":"c07bc55b5f0855854b32","993":"a67f9d51e5de3624c8e7"}[chunkId] + ".js");